<template>
  <div>
    <title-paid title="Facturas Em Análise"></title-paid>
    <analyze-component></analyze-component>
  </div>
</template>

<script>
import Title from "../geral/Title";
import AnalyzeComponent from "./invoices/AnalyzeComponent";
export default {
  components: { AnalyzeComponent, "title-paid": Title },
  name: "AnalizeInvoice"
};
</script>

<style scoped></style>

<style scoped></style>
